import type { BookingSummaryRow } from "@/types";
import { formatWhen } from "./metrics";

const STATUS_LABEL: Record<string, string> = {
  confirmed: "Confirmada",
  pending: "Pendiente",
  completed: "Completada",
  cancelled: "Cancelada",
  no_show: "No show",
};

const STATUS_CLASS: Record<string, string> = {
  confirmed: "bg-yellow-500/10 text-yellow-500",
  pending: "bg-yellow-500/10 text-yellow-500",
  completed: "bg-green-500/10 text-green-500",
  cancelled: "bg-muted text-muted-foreground",
  no_show: "bg-destructive/10 text-destructive",
};

export function AppointmentList({
  title,
  rows,
  timezone,
  empty,
  hasMore,
  loadingMore,
  onLoadMore,
}: {
  title: string;
  rows: BookingSummaryRow[];
  timezone: string;
  empty: string;
  hasMore?: boolean;
  loadingMore?: boolean;
  onLoadMore?: () => void;
}) {
  return (
    <section className="rounded-xl border border-border bg-card">
      <h2 className="border-b border-border p-4 text-sm font-medium">{title}</h2>
      {rows.length === 0 ? (
        <p className="p-8 text-center text-sm text-muted-foreground">{empty}</p>
      ) : (
        <div className="divide-y divide-border">
          {rows.map((row) => (
            <div
              key={row.id}
              className="grid grid-cols-1 gap-1 px-4 py-3 sm:grid-cols-[140px_minmax(0,1fr)_auto] sm:items-center sm:gap-3"
            >
              <span className="text-xs tabular-nums text-muted-foreground">
                {formatWhen(row.starts_at, timezone)}
              </span>
              <div className="min-w-0">
                <p className="truncate text-sm font-medium">
                  {row.service_emoji ? `${row.service_emoji} ` : ""}
                  {row.service_name || row.client_name || "Cita"}
                </p>
                <p className="truncate text-xs text-muted-foreground">
                  {[row.client_name, row.staff_name, row.space_name]
                    .filter(Boolean)
                    .join(" · ")}
                </p>
              </div>
              <span
                className={`w-fit rounded-full px-2 py-0.5 text-xs ${STATUS_CLASS[row.status] || "bg-muted text-muted-foreground"}`}
              >
                {STATUS_LABEL[row.status] || row.status}
              </span>
            </div>
          ))}
        </div>
      )}
      {hasMore && onLoadMore && (
        <div className="border-t border-border p-3">
          <button
            type="button"
            onClick={onLoadMore}
            disabled={loadingMore}
            className="flex min-h-11 w-full items-center justify-center rounded-lg text-sm font-medium text-muted-foreground hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50"
          >
            {loadingMore ? "Cargando…" : "Ver más"}
          </button>
        </div>
      )}
    </section>
  );
}
